import React from "react";

const Footer = () => {
  return (
    <div className="w-full mx-auto bg-pink-600 mt-16  bottom-0 font-body">
      <div className="w-3/4 mx-auto flex justify-center items-center py-5">
        <span className="text-white flex items-center md:text-base text-lg">
          Made by Mohammad Raiyyan
        </span>
      </div>
    </div>
  );
};

export default Footer;
